export const clientSideLinks = [
  { to: '/client', label: 'Dashboard' },
  { to: '/client/all-jobs', label: 'Browse Jobs' },
  { to: '/client/post-job', label: 'Post Job' },
  { to: '/client/jobs', label: 'Active Jobs' },
  { to: '/client/applications', label: 'Applications' },
  { to: '/client/hired-jobs', label: 'Hired Jobs' },
  { to: '/client/completed-jobs', label: 'Completed Jobs' },
  { to: '/client/expired-jobs', label: 'Expired Jobs' },
  { to: '/client/payments', label: 'Payments' },
  { to: '/client/messages', label: 'Messages' },
  { to: '/client/profile', label: 'Profile' },
  { to: '/client/settings', label: 'Settings' },
];
